// 一套默认主题以及一套暗黑主题
import {defaultColor} from "@/assets/theme/colors/defaultColor"
import {darkColor} from "@/assets/theme/colors/darkColor";

export const themes = {
    default: defaultColor,
    dark: darkColor,
};